import _merge from 'lodash/merge'

import StoreCollectionModel from '../StoreCollection.js'

let PaymentsCollection = {}

_merge(PaymentsCollection, StoreCollectionModel, {
  state: {
    apiBaseUrl: '/api/v1/payments'
  }
})

export default PaymentsCollection
